<template>
  <div class="home">
    <div style="top:10px;position:absolute;left:10px;">
      <el-button type="primary" @click="back" plain>后退</el-button>
      <el-button type="primary" @click="box" plain>Settings</el-button>
    </div>

    <div class="content">
      <el-row :gutter="12">
        <el-col :span="24">
          <el-button size="medium" @click="typeClick()">轮播看板</el-button>
        </el-col>
      </el-row>
    </div>

    <el-dialog title="设置" width="880px" :close-on-click-modal="false" :visible.sync="dialogFormVisible">
      <el-alert title="设置需要轮播的看板网址，把网址复制到数据源输入框，每个数据源放一个网址，
      多个网址点击加号按钮添加，然后保存!" type="success" :closable="false">
      </el-alert>
      <el-form :model="ruleForm" status-icon ref="ruleForm" label-width="150px" :rules="rules">
        <el-form-item label="播放类型" prop="interval">
          <el-radio-group v-model="ruleForm.boxType">
            <el-radio :label="'A'">自动播放</el-radio>
            <el-radio :label="'M'">手动播放(使用键盘上下键或触控笔左右键)</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="间隔秒数" prop="interval">
          <el-input @input="intervalChange" v-model="ruleForm.interval">
            <template slot="append">秒</template>
          </el-input>
        </el-form-item>
        <el-form-item :label="`数据源${(i + 1)}`" v-for="(item, i) in ruleForm.urls" :key="i" :prop="`urls.${i}`"
          :rules="{ required: true, message: `请输入数据源${i + 1}`, trigger: ['blur'] }">
          <el-input v-model="ruleForm.urls[i]">
            <template #suffix>
              <el-button type="danger" @click="deleteUrl(i)">删除</el-button>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="showAnd('ruleForm')">+</el-button>
        </el-form-item>
        <el-form-item label="新增" v-if="isShowAnd">
          <!--<el-form-item :label="`数据源${(ruleForm.urls.length+1)}`" v-if="isShowAnd">-->
          <el-input @input="andUrlsChange" v-model="tmpUrl">
            <template #suffix>
              <el-button type="success" @click="andUrl()">添加</el-button>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="setBox('ruleForm')">确认</el-button>
          <el-button @click="defaultBox()">默认</el-button>
        </el-form-item>
      </el-form>

    </el-dialog>
  </div>
</template>
<script>
import router from "../../../router";

export default {
  name: 'my-frame',
  data() {
    var checkInterval = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("间隔秒数不能为空"));
      } else {
        callback();
      }
    };

    return {
      myIframe: {
        contentWindow: {
          src: null,
        }
      },
      timer: null,
      timerIndex: 0,
      isShowAnd: false,
      dialogFormVisible: false,
      interval: 30,
      urls: ["http://192.168.177.250/kanban/index.html#/nok/board","http://192.168.177.250/goview/index.html#/chart/preview/2c86813593ce6f170193e2c299330bfd"],
      tmpUrl: "",
      ruleForm: {
        boxType: 'A',
        interval: 30,
        urls: ["http://192.168.177.250/kanban/index.html#/nok/board","http://192.168.177.250/goview/index.html#/chart/preview/2c86813593ce6f170193e2c299330bfd"],
      },
      rules: {
        interval: [{ validator: checkInterval, trigger: "blur" }],
      },
    };
  },
  mounted() {
  },

  methods: {
    typeClick(data) {
      this.$router.push({
        path: "/box/board"
      });
    },
    box() {
      var box = localStorage.getItem("box");
      if (box) {
        box = JSON.parse(box);
        this.ruleForm.interval = box["interval"];
        this.ruleForm.urls = box["urls"];
        this.ruleForm.boxType = box['boxType'] || 'A';
      }
      this.dialogFormVisible = true;
    },
    intervalChange(value) {
      if (isNaN(value)) {
        value = parseInt(value);
        this.ruleForm.interval = isNaN(value) ? this.interval : value;
      }
    },

    andUrlsChange(value) {
      this.tmpUrl = value;
    },
    andUrl() {
      var reg = /(http|https):\/\//;
      // var reg=/(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/;
      var re = new RegExp(reg);
      if (re.test(this.tmpUrl)) {
        this.ruleForm.urls.push(this.tmpUrl);
        this.tmpUrl = "";
      } else {
        this.$message.error("请输入正确的网址,以http://或https://开头");
      }
    },
    deleteUrl(index) {
      this.ruleForm.urls.splice(index, 1);
    },
    showAnd(formName) {

      if (this.isShowAnd) {
        this.isShowAnd = !this.isShowAnd;
      } else {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isShowAnd = !this.isShowAnd;
          } else {
            return false;
          }
        });
      }


    },
    setBox(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var interval = this.ruleForm.interval;
          var urls = this.ruleForm.urls;
          var boxType = this.ruleForm.boxType;
          var box = { interval: interval, urls: urls, boxType: boxType };
          localStorage.setItem("box", JSON.stringify(box));
          this.dialogFormVisible = false;
        } else {
          return false;
        }
      });

    },
    defaultBox() {
      this.ruleForm.interval = this.interval;
      this.ruleForm.urls = this.urls;
      this.ruleForm.boxType = 'A'
    },
    back() {
      router.back();
    },

  },
}
</script>
<style scoped src='./category.css'></style>



// WEBPACK FOOTER //
// src/pages/box/category/category.vue